import { registerCondition } from 'core/forms';

import isPositiveInteger from '@/forms/validators/isPositiveInteger';

const isAttendanceMaxEmpty = ({ model: { attendance_max: fieldValue } }) => ({
  hasCondition: fieldValue === null || isPositiveInteger({ fieldValue }).hasError,
  condition: null,
});

registerCondition('videos:isAttendanceMaxEmpty', isAttendanceMaxEmpty);

export default isAttendanceMaxEmpty;
